// pipes
import { titleCasePipe } from 'shared/pipes';

// constants
import { COLORS_NOGO, FEEL_IN_CLOTHES, LOOK_AT_CLOTHES, PRINT_NOGO } from 'modules/customers/customer-edit/constants';

const StyleInfoView = ({ title, values }) => (
    <div className="content">
        <dl>
            <dt className="subtitle is-size-4 is-uppercase">{title}</dt>
            <div className="is-flex-mobile is-justify-content-flex-start is-flex-wrap-wrap">
                {values.map((value) => (
                    <dd key={value}>{value}</dd>
                ))}
            </div>
        </dl>
    </div>
);

const PickedStyleInfo = ({ name, data }) => {

    if (!data) { return null; }

    let d = data;
    if (typeof (data) === 'object') {
        d = data.toString();
    }

    const values = d?.split(',') || [];
    const title = titleCasePipe.transform(name);

    if (!values.length) { return null; }

    return (
        <div className="column has-text-centered is-6-mobile">
            <StyleInfoView title={title} values={values} />
        </div>
    );
};

const NotPickedStyleInfo = ({ name, data, fullData }) => {

    if (!data) { return null; }

    let d = data;
    if (typeof (data) === 'object') {
        d = data.toString();
    }

    const title = titleCasePipe.transform(name);
    const values = fullData.filter((v) => !d?.split(',').includes(v));

    if (!values.length) { return null; }

    return (
        <div className="column has-text-centered is-6-mobile">
            <StyleInfoView title={title} values={values} />
        </div>
    );
};

const Preferences = ({ customer }) => (
    <div className="container">
        <p className="title has-text-centered">
            {customer.type_of_clothes}
        </p>

        <div className="box">
            <div className="columns is-centered has-background-light is-multiline is-mobile">
                <NotPickedStyleInfo name="Colors" data={customer.colors_nogo} fullData={COLORS_NOGO} />
                <NotPickedStyleInfo name="Prints" data={customer.print_nogo} fullData={PRINT_NOGO} />
                <PickedStyleInfo name="Look at clothes" data={customer.look_at_clothes} />
                <PickedStyleInfo name="Feel in clothes" data={customer.feel_in_clothes} />
                <PickedStyleInfo name="Tone in Jewerly" data={customer.tone_of_jewellery} />
            </div>
        </div>

        <div className="box">
            <div className="columns is-centered has-background-danger is-multiline is-mobile">
                <PickedStyleInfo name="Colors nogo" data={customer.colors_nogo} />
                <PickedStyleInfo name="Prints nogo" data={customer.print_nogo} />
                <NotPickedStyleInfo name="Doesn't like in clothes" data={customer.look_at_clothes} fullData={LOOK_AT_CLOTHES} />
                <NotPickedStyleInfo name="Doesn't want to feel" data={customer.feel_in_clothes} fullData={FEEL_IN_CLOTHES} />
            </div>
        </div>
    </div>
);

export { Preferences };
